import React, { Component, useEffect, useState } from "react";
import ComponentAttendanceMobile from "./ComponentAttendanceMobile";
import ComponentAttendanceWeb from "./ComponentAttendanceWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentAttendance = () => {
  const gaEventTracker = useAnalyticsEventTracker("Attendance");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Attendance",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentAttendanceWeb></ComponentAttendanceWeb>
      </BrowserView>
      <MobileView>
        <ComponentAttendanceMobile></ComponentAttendanceMobile>
      </MobileView>
    </>
  );
};

export default ComponentAttendance;
